import { Component, OnInit, OnDestroy } from '@angular/core';
import { SharedService } from 'src/app/core/Services/shared.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TeamService } from '../../Services/team.service';
import { RBTeamMember } from '../../Models/Team';
import { NotificationService } from 'src/app/core/Services/notification.service';
import { VERBIAGE } from 'src/app/config';

@Component({
    selector: 'team-member-detail',
    templateUrl: 'team-member-detail.component.html',
    styleUrls: ['./team-member-detail.component.scss']
})

export class TeamMemberDetailComponent implements OnInit, OnDestroy{
    
    Member: RBTeamMember;

    constructor(
        private _shared: SharedService, private _route: ActivatedRoute,
        private _team: TeamService, private _router: Router, private _notify: NotificationService
    ) {
        // Show loader
        this._shared.loadingState = true;
    }

    async ngOnInit() {
        // Call service for member details
        const teammemberID = +this._route.snapshot.params.id;
        this.Member = <RBTeamMember>await this._team.getMemberByID(teammemberID);

        // Set page title as teammember name
        this._shared.pageTitle = this.Member.fullName;

        // Set up page controls
        const _this = this;
        this._shared.pageControls = [
            { type: '-icon-', title: 'Previous page', icon: 'arrow_back', action() { _this._router.navigate([_this._shared.getPreviousUrl]); }},
            { color: 'accent', type: '-icon-', title: 'Edit', icon: 'edit', action() {
                // Navigate to teammember edit page
                _this._router.navigate(['/dashboard/teammembers/edit', _this.Member.teammemberID]);
            }},
            { color: 'warn', type: '-icon-', title: 'Delete', icon: 'delete_outline', action() {
                _this.deleteTeamMember();
            }}
        ];

        this._shared.loadingState = false;
    }

    // Delete teammember
    deleteTeamMember() {
        const _this = this;
        // Ask for confirmation
        this._notify.openDialog({
            color: 'warn', title: VERBIAGE.DELETE_TEAMMEMBER_TITLE,
            body: (VERBIAGE.DELETE_TEAMMEMBER_NAME_DISPLAY) ?
                    `${VERBIAGE.DELETE_TEAMMEMBER_BODY_HEAD} <strong>${_this.Member.fullName}</strong> ${VERBIAGE.DELETE_TEAMMEMBER_BODY_TAIL}` :
                    `${VERBIAGE.DELETE_TEAMMEMBER_BODY_HEAD} ${VERBIAGE.DELETE_TEAMMEMBER_BODY_TAIL}`,

            handlers: [{
                text: 'Confirm', type: '-raised-', color: 'warn', action() {
                    // Deleted from DB
                    _this._team.deleteMemberByID(_this.Member.teammemberID).subscribe(res => {
                        if (res['status'] === 'OK') {
                            // Notify user deletion
                            _this._notify.toastMessage({
                                message: `${_this.Member.fullName} ${VERBIAGE.DELETE_TEAMMEMBER_SUCCESS}`,
                                duration: 3000, color: 'accent'
                            });
                            _this._router.navigate(['/dashboard/teammembers']);
                        }
                    }, err => _this._notify.toastMessage({
                        color: 'warn', message: VERBIAGE.DELETE_TEAMMEMBER_FAIL, duration: 3000
                    }));
                }
            }, { text: 'Cancel', type: '-raised-' }]
        });
    }

    ngOnDestroy() {
        // Remove page controls
        this._shared.pageControls = null;
    }
}